import { LoginOutlined } from '@ant-design/icons';
import { L } from '@lib';
import { GetUserOutput } from '@services';
import { Button, Col, Row, Tooltip, Typography } from 'antd';
import React from 'react';
import { SharedCard } from '.';

const { Title, Text } = Typography;
interface IProps {
  manager: GetUserOutput;
  handleImpersonation: (userId: number) => void;
}

export const GarageManagerDetailsCard: React.FC<IProps> = ({ manager, handleImpersonation }) => {
  return (
    <SharedCard>
      <Row justify="space-between">
        <Col span={4}>
          <Title level={5}>{L('Garage manager details')}</Title>
        </Col>
        <Col span={4}>
          <Title level={5}>{L('FULL NAME')}</Title>
          <br />
          <Text>
            {manager.name} {manager.surname}
          </Text>
        </Col>
        <Col span={4}>
          <Title level={5}>{L('EMAIL')}</Title>
          <br />
          <Text>{manager.emailAddress}</Text>
        </Col>
        <Col span={4}>
          <Title level={5}>{L('PHONE')}</Title>
          <br />
          <Text>{manager.phoneNumber}</Text>
        </Col>
        <Col offset={2} span={2}>
          <Tooltip title={L('Login to impersonate this garage')}>
            <Button
              onClick={() => handleImpersonation(manager.id)}
              icon={<LoginOutlined />}
              type="text"
            >
              {L('Login')}
            </Button>
          </Tooltip>
        </Col>
      </Row>
    </SharedCard>
  );
};
